import React from "react";
import { usePageSeo } from "../utils/seo";

function DataDeletion() {
  usePageSeo({
    title: "Data Deletion Instructions | Buzz Mobile",
    description:
      "Instructions for requesting deletion of personal data related to Buzz Mobile website and Meta/Facebook integrations.",
    canonicalPath: "/data-deletion",
  });

  return (
    <main className="privacy-policy-page">
      <section className="container privacy-policy">
        <header className="privacy-policy__header">
          <span>Last updated: July 2, 2026</span>
          <h1>Data Deletion Instructions</h1>
          <p>
            Buzz Mobile respects your privacy. If you want to request deletion
            of personal data connected to our website, services, or official
            Meta/Facebook Page integrations, you can contact us using the
            instructions below.
          </p>
        </header>

        <div className="privacy-policy__content">
          <section>
            <h2>How To Request Data Deletion</h2>
            <p>
              Send an email to Buzz Mobile with the subject line "Data Deletion
              Request". Please include enough information for us to identify
              your request, such as your name, email address, phone number, or
              order/service details if applicable.
            </p>
            <address>
              <strong>Buzz Mobile</strong>
              <span>Strumica, North Macedonia</span>
              <a href="mailto:buzzmobiledooel@gmail.com?subject=Data%20Deletion%20Request">
                buzzmobiledooel@gmail.com
              </a>
            </address>
          </section>

          <section>
            <h2>Facebook / Meta Data</h2>
            <p>
              Buzz Mobile does not use Facebook Login for website visitors and
              does not collect personal Facebook profile data from visitors or
              customers through this application.
            </p>
            <p>
              Our Meta/Facebook API usage is limited to managing and publishing
              content on official Buzz Mobile Facebook Page(s). If you believe
              we have received or stored personal data related to you through a
              Meta/Facebook integration, you may request deletion by email.
            </p>
          </section>

          <section>
            <h2>What Happens Next</h2>
            <p>
              After receiving your request, we will review it and delete or
              anonymize applicable personal information where reasonably possible
              and where we are not required to keep it for legal, accounting,
              security, fraud prevention, or business record purposes.
            </p>
          </section>
        </div>
      </section>
    </main>
  );
}

export default DataDeletion;
